<div
  id="confirmation"
  class="h-full flex justify-center items-center bg-success-off-white px-8 py-10 md:px-20 md:py-14">
  <div
    class="box-white py-12 text-center w-full h-auto px-14 md:w-128 md:h-72 md:px-20">
    <img
      class="m-auto"
      src="/assets/img/checkmark-green-icon.svg"
      alt="Green checkmark icon" />
    <h2 class="my-4">Order Placed!</h2>
    <h4 class="font-normal text-gray-500">
      Your order was placed successfully.
    </h4>
  </div>
</div>
